/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ domain: NonNullable<unknown>, system: NonNullable<unknown> }} Issue_Mapping_FieldInputs */

const en_issue_mapping_field = /** @type {(inputs: Issue_Mapping_FieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.domain} in ${i?.system}`)
};

/**
* | output |
* | --- |
* | "{domain} in {system}" |
*
* @param {Issue_Mapping_FieldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_mapping_field = /** @type {((inputs: Issue_Mapping_FieldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Mapping_FieldInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_mapping_field(inputs)
});